import { render, staticRenderFns } from "./PortfolioSettingsPage.vue?vue&type=template&id=42b7d438"
import script from "./PortfolioSettingsPage.vue?vue&type=script&lang=ts"
export * from "./PortfolioSettingsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports